// extracted by mini-css-extract-plugin
export default {"entitlementPagePillButtons":"Entitlement_entitlementPagePillButtons__XsHIh"};